<template>
  <v-container class="compact">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container class="titles">


          <v-row v-for="title in k9.titles" :key="title.id">
            <v-col cols="12" sm="1">{{ title.titleCode }}</v-col>
            <v-col cols="12" sm="2">{{ $itmStore.titles[title.titleCode].titleName }}</v-col>
            <v-col cols="12" sm="2">{{ $iso2AU(title.dateEarned) }}</v-col>
            <v-col cols="12" sm="5">{{ title.comment }}</v-col>
            <v-col cols="12" sm="1">
              <v-icon
                  small
                  @click="rmTitle(title.id)"
              >
                mdi-delete
              </v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-btn color="blue darken-1" @click="addTitleForm">{{ btnText }} title form</v-btn>
          </v-row>
          <v-form v-show="showForm">
            <v-row>
              <v-col cols="12" sm="5">

                <v-select v-model="titleCode"
                          :items="$itmStore.titleList"
                          item-text="titleName"
                          item-value="titleCode"
                          label="Title"></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="5">
                <DateField :rcvd-date="dateEarned" :itm-key="dateKey" @datechanged="whenEarned" lbl="Date">
                </DateField>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12">
                <v-textarea v-model="earned" label="Place earned, comments"></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="5">
                <v-btn color="blue darken-1" @click="addTitle">Add this title</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import DateField from './DateField'
//import usrInfo from '@/modules/acswUtils'

export default {
  name: "TitleEdit",
  components: {
    DateField
  },
  watch: {
    dog(newDog) {
      console.log(newDog)
      if (newDog) {
        this.k9 = Object.assign({}, newDog)
        this.savedDog = JSON.stringify(newDog, 3)
      } else {
        this.savedDog = ''
      }
      this.mNbr = this.dog.Member.mNbr
    },
  },
  props: {
    dog: {
      type: Object,
      default: () => {
      }
    },
  },
  data: () => ({
    k9: {},
    titleCode: {},
    showForm: false,
    earned: '',
    dateEarned: null,
    savedDog: '',
    mNbr: ''
  }),
  computed: {
    formTitle() {
      return `Titles Earned by ${this.k9.kNbr || ''} ${this.k9.callName}`
    },
    btnText() {
      if (this.showForm) {
        return 'Hide'
      } else {
        return 'Show'
      }
    },
    titleCodes() {
      return Object.keys(this.$itmStore.titles)
    },
    dateKey() {
      let k1 = 'x'
      if (this.k9) {
        k1 = this.k9.kNbr
      }
      if (this.dateEarned) {
        k1 = k1 + this.dateEarned.toString()
      }
      return k1
    },
  },
  mounted: function () {
    console.log('TitleEdit mounted')
    this.k9 = Object.assign({}, this.dog)
  },
  methods: {
    addTitleForm() {
      this.showForm = !this.showForm
    },
    whenEarned(event) {
      this.dateEarned = event
    },

    addTitle() {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/addtitle', {
        token: theToken,
        titleCode: this.titleCode,
        dateEarned: this.dateEarned,
        comment: this.earned,
        dogId: this.k9.id,
        trialEntry: null,
        leg: null
      })
          .then(response => {
            localStorage.setItem('token', response.data.token)
            this.k9 = response.data.dog
            this.dog = response.data.dog
          }).catch(reason => {
        alert('The server reported the following error: ' + reason)
      })
      this.showForm = false
    },
    rmTitle(id) {
      if (!confirm("Please verify that you want to permanently delete this title")) {
        return false
      }
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/rmtitle', {
        token: theToken,
        id: id,
        dogId: this.k9.id
      })
          .then(response => {
            localStorage.setItem('token', response.data.token)
            this.k9 = response.data.dog
            this.dog = response.data.dog
          }).catch(reason => {
        alert('The server reported the following error: ' + reason)
      })
      this.showForm = false
    },
    dis() {
      return false
    },

    close: function () {
      try {
        this.$emit('endTitleEdit', this.k9)
      } catch {
        this.$emit('endTitleEdit', null)
      }
    },
    save() {
      this.$emit('endTitleEdit', this.editedItem)
    },

  }
}
</script>

<style scoped>
.titles {
  text-align: left
}
</style>
